export const experienceData = [
    {
        id: 1,
        company: 'Zurita Company Ltd',
        jobtitle: 'IT Support Engineer',
        startYear: '2023',
        endYear: 'Present',
        location: 'Kiambu',
        description: [
            'Designed n8n workflows connecting Google Calendar API + Gmail to automate meeting scheduling and follow-ups.',
            'Automated daily backup verification and server health checks using n8n workflows, reducing manual checks by 90%.',
            'Built a Notion dashboard to track IT assets, maintenance schedules, and incident reports for three departments.',
            'Used ChatGPT to draft SOPs and troubleshooting guides, cutting documentation time by 60%.',
            'Managed Google Workspace, email filters, and calendar integrations to streamline team operations.'
        ]
    },
    {
        id: 2,
        company: 'Lehigh Recoveries',
        jobtitle: 'System Administrator',
        startYear: '2023',
        endYear: '2024',
        location: 'Nairobi',
        description: [
            'Created automated email routing rules and calendar scheduling workflows using n8n + Google Calendar API.',
            'Developed a Claude Code script to parse server logs and flag anomalies, reducing outage response time.',
            'Organized digital filing in Google Drive and trained staff on folder structures and naming conventions.'
        ]
    },
    {
        id: 3,
        company: 'Pergamon Group',
        jobtitle: 'Software Support Engineer',
        startYear: '2022',
        endYear: '2023',
        location: 'Nairobi',
        description: [
            'Built internal automation tools connecting client CRMs to internal tracking sheets via API calls.',
            'Used Canva to create client-facing documentation and system diagrams, improving onboarding speed.',
            'Provided technical support and proactive client communication, resolving issues on-site and remotely.'
        ]
    },
    {
        id: 4,
        company: 'Eclectics International',
        jobtitle: 'Back-end Developer Intern',
        startYear: '2022',
        endYear: '2022',
        location: 'Nairobi',
        description: [
            'Developed a movie rental API (Spring Boot, JWT, MySQL, Docker) – direct experience applicable to API integrations in n8n/Zapier.',
            'Wrote thorough test suites and API documentation, demonstrating an automation-first mindset.'
        ]
    },
]